@if ((entity$ | async)?.federationId === null) {
  <page-header>
    <a [routerLink]="federationsRoutePath" page-header-area="button" class="btn-link"
    translate="Actions.BackToFederations" data-cy="BackToFederations"></a>
  </page-header>
}

<div class="content-block has-padding" [class.block-loader]="(loader.isLoading$ | async)">
  <loader-spinner [model]="loader"/>
  <federation-form [value]="entity$ | async" (cancelForm)="onCancel()" (deleteForm)="onDelete($event)" (submitForm)="onSubmit($event)"/>
</div>
